<!--  -->
<template>
  <div class="dsawr">
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="turntable_user_id"
        label="用户id"
        width="180"
        align="center"
      />
      <el-table-column
        prop="book_currency"
        label="书币数量"
        width="180"
        align="center"
      />
      <!-- <el-table-column
        prop="is_exchange_text"
        label="是否兑换"
        align="center"
      />  -->
      <el-table-column
        prop="type_text"
        label="操作详情"
        align="center"
        width="600"
      />
      <el-table-column
        prop="admin_name"
        label="管理员"
        align="center"
        width="200"
      />
      <el-table-column
        prop="created_at_text"
        label="创建日期"
        align="center"
      />
      <!-- <el-table-column
        prop="sign_date"
        label="签到日期"
        width="180"
        align="center"
      />
      <el-table-column
        prop="continued_date"
        label="连续签到天数"
        width="180"
        align="center"
      /> -->
      <!-- <el-table-column
        prop="accounts_name"
        label="小程序名"
        align="center"
      />
      <el-table-column
        prop="is_exchange_text"
        label="是否兑换"
        align="center"
      /> -->
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { activityurntablegiveDeductRecordList } from '@/api/sourceminiprogram.js'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      tableData: [],
      total: null,
      pageIfon: {
        page: 1,
        pageSize: 10
      },
      keyword: null
    }
  },
  created() {
    console.log(this.$route.query)
    this.keyword = this.$route.query.id
    if (this.$route.query.type === 1) {
      this.exchangedata()
    } else {
      this.exchangeninedata()
    }
  },
  mounted() {},
  methods: {
    async exchangedata() {
      const data = await activityurntablegiveDeductRecordList({
        user_id: this.keyword,
        page: this.pageIfon.page,
        page_size: this.pageIfon.pageSize
      })
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    async exchangeninedata() {
      const data = await activityurntablegiveDeductRecordList({
        user_id: this.keyword,
        page: this.pageIfon.page,
        page_size: this.pageIfon.pageSize
      })
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      if (this.$route.query.type === 1) {
        this.exchangedata()
      } else {
        this.exchangeninedata()
      }
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      if (this.$route.query.type === 1) {
        this.exchangedata()
      } else {
        this.exchangeninedata()
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.dsawr {
  padding: 20px;
}
</style>
